// @ts-nocheck
import { useEffect } from "react";

// This hook manages the registration of graph control functions for opening modals in the forecast graphs component
// It ensures that the control functions are registered when the component mounts and cleaned up when it unmounts

const useGraphControls = ({
  onRegisterControls,
  setIsTimeRangeModalOpen,
  setIsDatasetModalOpen,
  currentViewRef,
  selectedTimeRange,
}) => {
  // Register control functions on mount and clean up on unmount
  useEffect(() => {
    if (typeof onRegisterControls !== "function") {
      return;
    }
     onRegisterControls({
      openTimeRange: () => setIsTimeRangeModalOpen(true),
      openDataset: () => setIsDatasetModalOpen(true),
      getCurrentRange: () => currentViewRef?.current || null,
      selectedTimeRange,
    });

    return () => {
      onRegisterControls({ openTimeRange: null, openDataset: null, getCurrentRange: null, selectedTimeRange: null });
    };
  }, [onRegisterControls, setIsTimeRangeModalOpen, setIsDatasetModalOpen, currentViewRef, selectedTimeRange]);
};

export default useGraphControls;
